module.exports = __webpack_public_path__ + "img/memo_info.09b6f9a4.svg";